import { z } from "zod";
import { BaseConfigurationsOutputItemWithColorSchema } from "@/Schemas/Configurations/BaseConfigurationsOutputItem";

export const ConfigurationsSourceOutputItemSchema = BaseConfigurationsOutputItemWithColorSchema.extend({
    requestTypeConnections: z.array(z.number()).nullish(),
});

export type ConfigurationsSourceOutputItem = z.infer<typeof ConfigurationsSourceOutputItemSchema>;

export const ConfigurationsSourceOutputSchema = z.object({
    items: z.array(ConfigurationsSourceOutputItemSchema),
});

export type ConfigurationsSourceOutputSchema = z.infer<typeof ConfigurationsSourceOutputSchema>;